import {APIRequest} from "./APIRequest.js";
import {signKBTransactionJWT} from "../Crypto/utils";
import {MyServices, WebTools} from "../constants";
import {approximateTokenSize} from "../Chat/utils";
import {getVPCServiceWithoutSlash} from "../App/utils";

const OPENAI_API_URL = getVPCServiceWithoutSlash('openai') || 'https://openai.openkbs.com';

export const createEmbeddingItem = async (input, KB) => {
    const model = KB?.embeddingModel;
    let apiResponse = await createEmbedding(input, model, KB);
    let embeddings = apiResponse.data[0].embedding.slice(0, KB.embeddingDimension);
    const totalTokens = apiResponse.usage.total_tokens;

    return {embeddings, totalTokens};
};

export const createEmbedding = async (input, model, KB) => {

    let myInput = input;
    let iterations = 0;
    const maxIterations = 1000;
    while (approximateTokenSize(myInput) > 7000 && iterations < maxIterations) {
        myInput = myInput.slice(0, -100); // Remove the last 100 characters
        iterations++;
    }

    try {
        const data = {
            action: 'createEmbedding',
            model: model,
            input: myInput
        };

        const transactionJWT = await signKBTransactionJWT({
            toAccountId: MyServices?.[model]?.accountId,
            ...KB,
            message: 'create text embedding'})

        const response = await APIRequest('post', OPENAI_API_URL, data, {
            headers: {
                'transaction-jwt': transactionJWT
            }
        });

        return response?.data;
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};

export const detectLanguage = async (text, KB, smallLimit = 100, bigLimit = 300) => {
    if (text) {
        let newText = text.substring(0, smallLimit);
        const words = newText.split(/\s+/);

        if (words.length < 3) {
            newText = text.substring(0, bigLimit)
        }

        try {
            return await translate(newText, KB, 'detect');
        } catch (e) {

        }
    }

    return { detection: { language: 'en' } };
}

// In-memory cache object
const translationCache = {};

export const translate = async (text, KB, method = 'translate') => {
    const token = localStorage.getItem('kbJWT');

    const transactionJWT = await signKBTransactionJWT({
        toAccountId: WebTools["translateText"]?.accountId,
        ...KB,
        message: 'translate text'
    })

    try {
        // Split the input text into sentences using a regex to handle variable whitespace
        const sentences = text.split(/,\s*/);
        const newSentences = [];
        let cachedTranslationParts = [];

        // Check each sentence for a cached translation
        sentences.forEach(sentence => {
            const trimmedSentence = sentence.trim();
            if (translationCache[trimmedSentence]) {
                // If the sentence is in the cache, use the cached translation
                cachedTranslationParts.push(translationCache[trimmedSentence]);
            } else {
                // If not, add it to the list of new sentences to translate
                newSentences.push(trimmedSentence);
            }
        });

        // If there are new sentences to translate, call the API
        if (newSentences.length > 0) {
            const newText = newSentences.join(', ');
            let url = `${WebTools["translateText"]?.url}?token=` + encodeURIComponent(token);
            url += `&transactionJWT=${encodeURIComponent(transactionJWT)}`

            const response = await APIRequest("post", url, {
                method,
                text: newText,
            }, {timeout: 60000});

            if (method === 'detect') return response?.data

            // Update the cache with the new translations
            const translatedSentences = response?.data?.translation?.split(/,\s*/);

            if (translatedSentences?.length){
                newSentences.forEach((sentence, index) => {
                    translationCache[sentence] = translatedSentences[index];
                    cachedTranslationParts.push(translatedSentences[index]);
                });
            }

        }

        // Combine the cached translations with the new translations
        return {
            translation: cachedTranslationParts.join(', ')
        };
    } catch (error) {
        console.error('API request error:', error);
        throw error;
    }
};